<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-knife`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.369 20.654l3.901 3.902a2 2 0 010 2.828L27.067 39.588c-6.64 6.639-17.403 6.639-24.042 0a2 2 0 010-2.829L36.26 3.525a2 2 0 012.829 0l5.29 5.291a2 2 0 010 2.828l-9.01 9.01zm4.767-10.424l-2.463-2.462-7.595 7.595 2.462 2.463 7.596-7.596zM24.238 36.76c-4.596 4.595-11.777 5.03-16.862 1.305l19.876-19.87 7.776 7.775-10.79 10.79z"/></svg>
</template>
<script>

export default {
  name: 'IconKnife',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
